import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { Deviation } from 'src/app/models/deviation.model';
import { Role } from 'src/app/models/role.model';
import { FaultType } from 'src/app/models/faultType.model';
import { TranslateService } from '@ngx-translate/core';
import { Language } from 'src/app/models/language.enum';
import { FunctionGroup } from 'src/app/models/functionGroup.model';
import { Responsible } from 'src/app/models/responsible.model';

@Component({
  selector: 'app-deviations-list-element',
  templateUrl: './deviations-list-element.component.html',
  styleUrl: './deviations-list-element.component.less'
})
export class DeviationsListElementComponent {

  @Input({ required: true }) deviation!: Deviation;
  @Input({ required: true }) roleAuth!: Role;
  @Input() problemDetailEnabled = false;
  @Input() isVisible = true;
  @Input() isInsideAccordion = false;

  @Output() openDeviationPopupEvent = new EventEmitter<any>();
  @Output() openSolvePopupEvent = new EventEmitter<any>();
  
  constructor(
    private clipboard: Clipboard,
    private translate: TranslateService
  ) {}

  openDeviationPopup(event?: Event, disableForm = false) {
    event?.stopPropagation();
    
    this.openDeviationPopupEvent.emit(disableForm);
  }

  openSolvePopup(event?: Event) {
    event?.stopPropagation();
    
    this.openSolvePopupEvent.emit();
  }
  
  //LANGUAGE SETTING
  getFaultTypeRank2Name(faultType: FaultType | null){
    if (faultType == null) { return ""; }

    if (this.translate.currentLang === Language.French) {
      return faultType.rank2NameFR;
    } else if (this.translate.currentLang === Language.Dutch) {
      return faultType.rank2NameNL;
    } else {
      return faultType.rank2NameEN;
    }
  }

  getFunctionFullPath(dev: Deviation) {
    if (dev == null) { return ""; }

    return [this.getTreeElementName(dev.functionGroupLevel1),
            this.getTreeElementName(dev.functionGroupLevel2),
            this.getTreeElementName(dev.functionGroupLevel3),
            this.getTreeElementName(dev.functionGroupLevel4)
      ].filter(Boolean).join(" > ").replace(/^ >+/, '').trim();
  }

  getProblemDetailFullPath(dev: Deviation) {
    if (dev == null) { return ""; }

    return [this.getTreeElementName(dev.problemDetailLevel1),
            this.getTreeElementName(dev.problemDetailLevel2),
            this.getTreeElementName(dev.problemDetailLevel3),
            this.getTreeElementName(dev.problemDetailLevel4)
      ].filter(Boolean).join(" > ").replace(/^ >+/, '').trim();
  }

  getResponsibleFullPath(dev: Deviation) {
    if (dev == null) { return ""; }

    return [this.getTreeElementName(dev.responsibleLevel2),
            this.getTreeElementName(dev.responsibleLevel3)
      ].filter(Boolean).join(" > ").replace(/^ >+/, '').trim();
  }

  //LANGUAGE SETTING
  getTreeElementName(f?: Responsible | FunctionGroup | null) {
    if (f == null) { return "";} 

    if (this.translate.currentLang === Language.French) {
      return f?.nameFR;
    } else if (this.translate.currentLang === Language.Dutch) {
      return f?.nameNL;
    } else {
      return f?.nameEN;
    }
  }

  //CLIPBOARD
  copyDirectLink(displayId: string, event?: any) {
    event?.stopPropagation();
    const httpName = window.location.href.split("/", 5)[2].includes("localhost") ? 'http://' : 'https://';
    const link = `${httpName}${window.location.href.split("/", 5)[2]}/deviations-list/displayid/${displayId}`;
    this.clipboard.copy(link);
  }

}
